<template>
  <div class="login">
    <!-- <video-bg
      v-if="!hideVideoBackground"
      id="background-video"
      class="video-background"
      :sources="videoSource"
      img=""
    />-->

    <!-- topbar -->
    <transition name="slide-in-down" appear appear-active-class="animated slideInDown">
      <v-toolbar>
        <v-toolbar-title icon>
          <v-icon class="no-select" v-html="'fa-chalkboard-teacher'" style="font-size:36px; color:rgb(10, 60, 100);" />
        </v-toolbar-title>
        <v-toolbar-title>
          <span style="text-transform: uppercase;">{{ $t('Accounting & POS System') }}</span>
        </v-toolbar-title>
        <v-spacer />
        <!-- <v-menu bottom left offset-y transition="slide-y-reverse-transition">
          <v-btn large slot="activator" icon>
            <v-icon large>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile style="height:50px;">
              <v-tooltip bottom>
                <v-switch
                  slot="activator"
                  v-model="isCashierLogin"
                  :label="$t('Cashier Login')"
                  class="cashier-toggle"
                  color="primary"
                />
                <span>{{ $t('Choose to login as cashier or the back-office') }}</span>
              </v-tooltip>
            </v-list-tile>
            <v-list-tile style="height:50px;">
              <v-switch
                v-model="hideVideoBackground"
                :label="$t('Hide Video Background')"
                class="cashier-toggle"
                color="primary"
              />
            </v-list-tile>
          </v-list>
        </v-menu>-->
      </v-toolbar>
    </transition>
    <!-- / topbar -->

    <v-layout wrap align-center id="form-container">
      <v-window v-model="isCashierLogin" :style="`position:relative; top: 100px`">
        <v-window-item :value="true">
          <!-- Cashier Form -->
          <cashier-form />
        </v-window-item>

        <v-window-item :value="false">
          <!-- Admin Form -->
          <admin-form />
        </v-window-item>
      </v-window>
    </v-layout>

    <!-- Footer -->
    <app-footer />
  </div>
</template>

<script>
import cashierFormVue from './cashierForm.vue'
import adminFormVue from './adminForm.vue'
import AppFooterVue from '../_partials/AppFooter.vue'

export default {
  name: 'Login',

  components: {
    cashierForm: cashierFormVue,
    adminForm: adminFormVue,
    appFooter: AppFooterVue
  },

  data() {
    return {
      baseurl: `${window.location.protocol}//${window.location.hostname}`,
      // videoSource: ['http://pos-build.test/assets/vids/video-1.mp4'],
      isCashierLogin: false,
      showAdminFormImmediately: false,
      hideVideoBackground: false
    }
  },

  mounted() {
    this.isCashierLogin = false
    // this.controlBackgroundVideo()
    // this.togglePausingBackgroundVideo()
  },

  methods: {
    getScreenResolution() {
      this.screenHeight = window.screen.height
    },

    controlBackgroundVideo() {
      document.querySelector('#background-video video').playbackRate = 0.8
    },

    togglePausingBackgroundVideo() {
      let bgVideo = document.querySelector('#background-video video')
      let videoContent = document.querySelector('.VideoBg__content')

      videoContent.addEventListener('click', () => {
        if (bgVideo.paused) {
          bgVideo.play()
        } else {
          bgVideo.pause()
        }
      })
    }
  }
}
</script>

<style scoped>
.v-toolbar {
  position: fixed;
  top: 0;
  z-index: 999;
}

.video-background {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  opacity: 0.4;
}

#form-container {
  position: absolute;
  width: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.v-alert {
  width: 300px;
}

.mi-slideInUp {
  transform: translateY(20%);
}
.v-input__slot {
  margin-bottom: 0 !important;
}
.v-window {
  width: 100% !important;
}

@media screen and (max-width: 767px) {
  .video-background {
    display: none;
  }
}

@media screen and (max-height: 760px) {
  #form-container {
    margin-bottom: 150px;
  }
}
</style>
